import { generateID } from '@/utils/ruoyi';
import dayjs from 'dayjs'
const useInvoiceStore = defineStore('invoiceV2', {
    state: () => ({
        sysSetting: {
            seller: {
                "name": "北京仁和科技有限公司",
                "address": "北京昌平区流光大厦666号",
                "phone": "18910430134",
                "taxRegistrationNo": "91110104533585261H",
                "bank": "中国建设银行",
                "account": "6224797589073468960",
            },
            bank: {
                "balance": null,
                "invoiceAmount": 100,
                "initMoney": "1000000000",
            }
        },
        buyerCategory: [], //客户分类数据
        buyerList: [], //客户列表
        productCategory: [],//项目分类数据
        productList: [],//项目列表数据
        blueInvoiceList: [],
        redInvoiceList: []
    }),
    actions: {
        //添加客户种类
        addBuyerCategroy (data) {
            let params = {
                id: generateID(19),
                creatorId: '1856898486125379586',
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                isDeleted: 0,
                bookId: generateID(19),
                name: null,
            }
            params.name = data.name;
            this.buyerCategory.push(params);
        },
        //更新客户种类
        updateBuyerCategroy (data) {
            this.buyerCategory.forEach(item => {
                if (item.id == data.id) {
                    item.name = data.name
                }
            })
        },
        //添加客户数据
        addBuyer (data) {
            let params = Object.assign({
                id: generateID(19),
                creatorId: '1856898486125379586',
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                updatorId: '',
                updateTime: '',
            }, data)
            this.buyerList.push(params)
        },
        // 删除客户
        delBuyer(ids){
            this.buyerList = this.buyerList.filter(f => !ids.some(s => s == f.id))
        },
        //更新客户信息
        updateBuyer (data) {
            this.buyerList.forEach(item => {
                if (item.id == data.id) {
                    Object.assign(item, data)
                }
            })
        },
        //添加项目种类
        addProductCategroy (data) {
            let params = {
                id: generateID(19),
                creatorId: '1856898486125379586',
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                isDeleted: 0,
                bookId: generateID(19),
                name: null,
            }
            params.name = data.name;
            this.productCategory.push(params);
        },
        //更新项目种类
        updateProductCategroy (data) {
            this.productCategory.forEach(item => {
                if (item.id == data.id) {
                    item.name = data.name
                }
            })
        },
        //添加项目
        addProduct (data) {
            let params = Object.assign({
                id: generateID(19),
                creatorId: '1856898486125379586',
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                updatorId: '',
                updateTime: '',
            }, data)
            this.productList.push(params)
        },
        // 删除项目
        delProject(ids) {
            this.productList = this.productList.filter(f => !ids.some(s => s == f.id))
        },
        //更新项目
        updateProduct (data) {
            this.productList.forEach(item => {
                if (item.id == data.id) {
                    Object.assign(item, data)
                }
            })
        },
        //添加蓝字发票
        addBlueInvoice (data, qaType) {
            let number = generateID(19)
            switch (qaType) {
                case '31':
                    number = '25110000008357913999'
                    break
                case '32':
                    number = '25110000034622815918'
                    break
                case '33':
                    number = '25110000055755052975'
                    break
                case '35':
                    number = '25000016853038649127'
                    break
                case '37':
                    number = '25000016120059335201'
                    break
                case '36':
                    number = '25000016956825503609'
                    break
            }
            let params = Object.assign(data, {
                id: generateID(19),
                number: number,
                creatorId: '1856898486125379586',
                createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                updatorId: '',
                updateTime: '',
            })
            this.blueInvoiceList.push(params)
        },
        //添加红字发票
        addRedInvoice (data) {
            let params = Object.assign(data, {
                id: generateID(19),
                isQueren: 1,
                kaijuStatus: 0,
            })
            this.redInvoiceList.push(params)
        },
        //开具红字开票
        operateRedInvoice (id) {
            this.redInvoiceList.forEach(item => {
                if (item.id == id) {
                    item.kaijuStatus = 1
                }
            })
        }
    },
    getters: {
        //蓝字汇总
        getBlueInvoiceStatistic: (state) => {
            const invoiceAmount = state.blueInvoiceList.length;
            const totalAmount = state.blueInvoiceList.reduce((sum, pre) => {
                return sum += Number(pre.totalAmount || 0)
            }, 0)
            const totalTaxAmount = state.blueInvoiceList.reduce((sum, pre) => {
                return sum += Number(pre.totalTaxAmount || 0)
            }, 0)
            const totalAddedTaxAmount = state.blueInvoiceList.reduce((sum, pre) => {
                return sum += Number(pre.totalTaxAmount || 0)
            }, 0);
            return {
                "invoiceAmount": invoiceAmount,
                "totalAddedTaxAmount": Number(totalAddedTaxAmount).toFixed(2),
                "totalAmount": Number(totalAmount).toFixed(2),
                "totalTaxAmount": Number(totalTaxAmount).toFixed(2),
            }
        },
        //授信用额度
        getCreditAmount: (state) => {
            const allMoney = state.sysSetting.bank.initMoney;
            const totalAmount = state.getBlueInvoiceStatistic.totalAmount;
            return (Number(allMoney) - Number(totalAmount)).toFixed(2)
        },
        //获取红字汇总
        getRedInvoiceStatistic: (state) => {
            const qrdList = state.redInvoiceList.filter((item) => item.isQueren == 1);
            const htsxed = qrdList.reduce((sum, pre) => {
                return sum += Number(pre.totalAmount || 0)
            }, 0)
            const fcqrd = qrdList.length;
            const fwqrdList = state.redInvoiceList.filter((item) => [2, 4].includes(item.isQueren));
            const sdqrd = fwqrdList.length;
            return {
                "htsxed": Number(htsxed).toFixed(2),
                "fcqrd": fcqrd,
                "sdqrd": sdqrd,
                "clzsdqrd": 3
            }
        }

    },
    persist: {
        enabled: true,
    }
})



export default useInvoiceStore
